import './shops.scss'
import PhotoSlider from './slider.js'

const shops = document.querySelectorAll('.ui-shops__node')

if (shops.length > 0) {
    shops.forEach((shop) => {
        const slider = new PhotoSlider(shop.querySelector('.ui-shops__swiper'))
    })

    document.querySelectorAll('.ui-shops-map').forEach((contactsMap) => {
        const parent = contactsMap.parentNode

        ymaps.ready(() => {
            const gpsN = parseFloat(contactsMap.getAttribute('data-gps-s')),
            gpsS = parseFloat(contactsMap.getAttribute('data-gps-n')),
            yMap = new ymaps.Map(contactsMap, {
                center: [gpsN, gpsS],
                zoom: 11,
                controls: ["zoomControl", "fullscreenControl"],
                checkZoomRange: true
            })
            
            yMap.behaviors.disable('scrollZoom')
            yMap.behaviors.disable('multiTouch')

            shops.forEach((store) => {
                const gpsN = parseFloat(store.getAttribute('data-gps-s')),
                gpsS = parseFloat(store.getAttribute('data-gps-n')),
                TITLE = store.querySelector('.ui-shops__node-title').textContent + '<br />' + store.querySelector('.ui-shops__node-address').textContent,
                PHONE = store.querySelector('.ui-shops__node-phone').textContent,
                pm = new ymaps.Placemark([gpsS, gpsN], {
                    hintContent: TITLE,
                    balloonContent: '<strong>' + TITLE + '</strong><br />Телефон: ' + PHONE + '',
                    iconContent: TITLE
                }, {
                    preset: 'islands#greenStretchyIcon'
                })
                
                yMap.geoObjects.add(pm);
            })
        })
    })
}